import {
  Flex, Icon, IconButton, Link, Menu, MenuButton, MenuDivider, MenuItem, MenuList, Td, Text, Tr,
} from '@chakra-ui/react';
import { Link as LinkR } from 'react-router-dom';
import {
  BsThreeDotsVertical, BsPencilFill, BsFillTrashFill,
} from 'react-icons/bs';
import { toDate } from '../../helpers/date';

const TemplateRow = ({
  row: {
    name, date, id, uses,
  },
  onDelete,
}) => (
  <Tr>
    <Td>
      <Flex direction="column">
        <Text fontWeight="bold">
          <Link
            as={LinkR}
            to={`/templates/${id}/edit`}
            state={{ title: name }}
            w="100%"
            display="inline-block"
            _hover={{ textDecor: 'none' }}
          >
            {name}
          </Link>
        </Text>
        <Text color="gray.400" fontSize="sm">
          Created on:
          {' '}
          {toDate(date)}
        </Text>
      </Flex>
    </Td>
    <Td>{uses}</Td>
    <Td>
      <Menu>
        <MenuButton
          as={IconButton}
          aria-label="Options"
          icon={<Icon as={BsThreeDotsVertical} />}
          variant="link"
        />
        <MenuList>
          <MenuItem icon={<Icon as={BsPencilFill} />} as={LinkR} to={`/templates/${id}/edit`}>
            Edit
          </MenuItem>
          <MenuDivider />
          <MenuItem icon={<Icon as={BsFillTrashFill} />} onClick={() => onDelete({ name, id })}>
            Delete
          </MenuItem>
        </MenuList>
      </Menu>
    </Td>
  </Tr>
);
export default TemplateRow;
